import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AlertResponse, AlertCreateRequest, AlertUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues, EntityUtils } from '../utils';
import { AlertDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { AssetGroupingService } from 'app/services';
import { EventFilterService } from 'app/services/events/event-filter.service';

@RegisterEntityHandler('alert')
@Injectable()
export class AlertHandler extends EntityHandler<AlertResponse> {

    constructor(
        admin: AdminEditorService,
        private grouping: AssetGroupingService,
        private filters: EventFilterService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listAlerts/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listAlerts(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'alert',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ALERTS'),
        }));
    }

    getEntity(id: string): Promise<AlertResponse> {
        return this.admin.getCached(`getAlert/${id}`, api => api.entities.getAlert(id), 10);
    }

    createEntity(ownerId: string, entity: AlertCreateRequest): Promise<AlertResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createAlert(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateAlert(entity.id, { state: state as any }));
    }

    getGridIcon(_item: AlertResponse): string {
        return ICONS.alert;
    }

    getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {
        return Promise.all([
            this.grouping.getCostCentres(ownerId),
        ]).then(([costCentres]) => {
            const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ALERT.COLUMNS');
            const columns: IKuiTableCol[] = [
                grid.IconTextColumn('name', 'NAME', this.getGridIcon),
                grid.IdNameComboColumn('costCentre', 'COST_CENTRE', EntityUtils.treeToComboFilter(costCentres), 150),
                grid.ComboColumn('priority', 'PRIORITY', EnumToComboValues(this.admin.i18n, 'ADMIN.EDITORS.ALERT.PRIORITIES', ['low', 'medium', 'high']), 80),
                grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', ['active', 'deleted'], ['deleted']), 80),
                grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
            ];
            return columns;
        });
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<AlertResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new AlertDetailsSectionHandler(this.admin, ownerId, false, this.filters),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: AlertUpdateRequest, sections: FormSectionHandler<AlertResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'alert',
            entity: {}, // set up some defaults if you want
            sections: [
                new AlertDetailsSectionHandler(this.admin, ownerId, true, this.filters),
            ],
        });
    }

}












